import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Sidebar.scss'


const Sidebar = ({ children, fullWidth }) => (
  <div className={cx(s.sidebar, { [s.fullWidth]: fullWidth })} data-testid="productsPageSidebar">
    {children}
  </div>
)

Sidebar.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
}


export default Sidebar
